<template>
    <el-dialog

            class="selectCustomer"
            title="选择产品"
            :visible="true"
             width="80%"
            :before-close="handleClose">

        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">

            <el-form-item label="产品编号:">
                <el-input v-model="form.product_sn" clearable></el-input>
            </el-form-item>

            <el-form-item label="产品名称:">
                <el-input v-model="form.product_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品条码:">
                <el-input v-model="form.production_bar_code" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品分类:" style="text-align: center">
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id1" size="small" @change="selectCateOne">
                        <el-option v-for=" i in categoryOne" :key="i.id" :label="i.cate_name"
                                   :value="i.id"></el-option>
                    </el-select>

                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id2" size="small">
                        <el-option v-for=" i in categoryTwo" :key="i.id" :label="i.cate_name"
                                   :value="i.id"></el-option>
                    </el-select>

                </el-col>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>
        <span style="margin-top: 10px">温馨提示：产品信息请在【资产】>【产品库】中添加。</span>
        <el-table
                style="margin-top: 10px"
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                stripe
                height="350"
                border>
            <el-table-column
                    prop="product_img"
                    label="产品图片"
                    width="80"
                    style="text-align: center"
                    fixed>
                <template slot-scope="scope">
                    <img :src="scope.row.product_img" alt="" style="width: 50px;height: 50px;display: block">
                </template>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="category_name"
                    label="产品分类"
                    width="120"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                   <span v-if="scope.row.category_name">{{scope.row.category_name}}</span>
                   <span v-else>未分类</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="product_bar_code"
                    label="产品条码"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
       <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>-->
    </el-dialog>
</template>

<script>
    export default {
        name: "selectProduct",
        data(){
            return{
                loading:false,
                form: {
                    product_sn:'',
                    product_name:'',
                    production_bar_code:'',
                    category_id1:'',
                    category_id2:'',
                },
                categoryOne: [],//一级分类
                categoryTwo: [],//二级分类
                tableData: [],
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
            }

        },
        methods:{
            //搜索
            onSearch(){
                let category_id = '';
                if(this.form.category_id2){
                    category_id = this.form.category_id2;
                }else{
                    category_id = this.form.category_id1;
                }
                this.loading = true;
                this.$get('logistics','/products', {
                    per_page:this.pageSize,
                    page:this.pageNo,
                    product_sn:this.form.product_sn,
                    product_name:this.form.product_name,
                    production_bar_code:this.form.production_bar_code,
                    category_id:category_id
                }).then(res => {
                    this.loading = false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });

            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.onSearch();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.onSearch();
            },
            //获取一级分类
            getCateOne(){
                this.$get('logistics','/products.category.one', {
                }).then(res => {
                    this.categoryOne = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //选择一级分类
            selectCateOne(val){
                this.form.category_id1 = val;
                this.categoryTwo = [];
                this.form.category_id2 = '';
                this.getCateTwo();
            },
            //获取二级分类
            getCateTwo(){
                this.$get('logistics','/products.category.two', {
                    category_id:this.form.category_id1
                }).then(res => {
                    this.categoryTwo = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //选择产品
            choose(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            handleClose(){
                this.$emit('handleClose');
            }

        },
        created(){
            this.getCateOne();
            this.onSearch();

        }
    }
</script>

<style lang="scss" scoped>

</style>